import { getStoreAccessors } from "typesafe-vuex";
import { State as RootState } from "../state";
import { AppState } from "@/store/appState/state";

export const mutations = {
  raiseError(state: AppState, payload: Error) {
    state.error = payload;
  },

  dismissError(state: AppState) {
    state.error = null;
  },

  setErrorTimeout(state: AppState, payload: number) {
    state.errorTimeout = payload;
  },

  setUnsavedChanges(state: AppState, payload: boolean) {
    state.hasUnsavedChanges = payload;
  }
};

const { commit } = getStoreAccessors<AppState, RootState>("");

export const commitRaiseError = commit(mutations.raiseError);
export const commitDismissError = commit(mutations.dismissError);
export const commitSetErrorTimeout = commit(mutations.setErrorTimeout);
export const commitHasUnsavedChanges = commit(mutations.setUnsavedChanges);
